<template>
  <div class="date-picker" v-click-outside:isOn>
    <label @click="togglePicker" class="trigger">
      <span class="displayed-value">{{ parseBeautifulDisplay }}</span>
    </label>
    <input
      placeholder=""
      class="input-date-picker"
      value="2019-08-31"
      name="availability"
      type="text"
      autocomplete="off"
    />

    <div class="picker" v-if="isOn">
      <header class="flex">
        <div class="header-calendar flex">
          <button class="previous-month" @click="switchMonth(-1)">
            <svg
              enable-background="new 0 0 451.846 451.847"
              height="451.85"
              viewBox="0 0 451.846 451.847"
              width="451.85"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m345.44 248.29-194.29 194.28c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744l171.91-171.91-171.91-171.9c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.29 194.28c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373"
              ></path>
            </svg>
          </button>
          <button class="current-month pick-month-and-year" data-date="2019-4">
            {{ $t("overall.month" + this.month) }} {{ this.year }}
          </button>
          <button class="next-month" @click="switchMonth(1)">
            <svg
              enable-background="new 0 0 451.846 451.847"
              height="451.85"
              viewBox="0 0 451.846 451.847"
              width="451.85"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m345.44 248.29-194.29 194.28c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744l171.91-171.91-171.91-171.9c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.29 194.28c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373"
              ></path>
            </svg>
          </button>
        </div>
        <div class="flex header-months-and-years hide">
          <strong>Pick year and month</strong>
          <button class="close">
            <svg
              enable-background="new 0 0 212.982 212.982"
              viewBox="0 0 212.982 212.982"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clip-rule="evenodd"
                d="m131.8 106.49 75.936-75.936c6.99-6.99 6.99-18.323 0-25.312-6.99-6.99-18.322-6.99-25.312 0l-75.937 75.937-75.937-75.938c-6.99-6.99-18.322-6.99-25.312 0-6.989 6.99-6.989 18.323 0 25.312l75.937 75.936-75.937 75.937c-6.989 6.99-6.989 18.323 0 25.312 6.99 6.99 18.322 6.99 25.312 0l75.937-75.937 75.937 75.937c6.989 6.99 18.322 6.99 25.312 0s6.99-18.322 0-25.312z"
                fill-rule="evenodd"
              ></path>
            </svg>
          </button>
        </div>
      </header>
      <div class="content">
        <div class="calendar">
          <div class="days">
            <ul>
              <li>{{ substr3($t("overall.day1")) }}</li>
              <li>{{ substr3($t("overall.day2")) }}</li>
              <li>{{ substr3($t("overall.day3")) }}</li>
              <li>{{ substr3($t("overall.day4")) }}</li>
              <li>{{ substr3($t("overall.day5")) }}</li>
              <li>{{ substr3($t("overall.day6")) }}</li>
              <li>{{ substr3($t("overall.day7")) }}</li>
            </ul>
          </div>
          <div class="figures">
            <div v-for="space in firstDay" class="blank-picker-day" :key="'datepicker-space-day' + space"></div>
            <button
              @click="selectValue(d)"
              v-for="d in daysNumber"
              class="date-picker-day"
              :class="isActive(d)"
              :key="'datepicker-day' + d"
            >
              <span>{{ d }}</span>
            </button>
          </div>
        </div>
        <div class="months-and-years hide">
          <div class="select year-picker">
            <span class="selected">2020</span>
            <ul class="options">
              <li v-for="p in 100" :key="'datepicker-year-' + p">{{ p + 2020 }}</li>
            </ul>
          </div>
          <ul class="flex months">
            <li>
              <button>{{ substr3($t("overall.month1")) }}</button>
            </li>
            <li>
              <button>{{ substr3($t("overall.month2")) }}</button>
            </li>
            <li>
              <button>{{ substr3($t("overall.month3")) }}</button>
            </li>
            <li>
              <button>{{ substr3($t("overall.month4")) }}</button>
            </li>
            <li>
              <button class="active">{{ substr3($t("overall.month5")) }}</button>
            </li>
            <li>
              <button>{{ substr3($t("overall.month6")) }}</button>
            </li>
            <li>
              <button>{{ substr3($t("overall.month7")) }}</button>
            </li>
            <li>
              <button>{{ substr3($t("overall.month8")) }}</button>
            </li>
            <li>
              <button>{{ substr3($t("overall.month9")) }}</button>
            </li>
            <li>
              <button>{{ substr3($t("overall.month10")) }}</button>
            </li>
            <li>
              <button>{{ substr3($t("overall.month11")) }}</button>
            </li>
            <li>
              <button>{{ substr3($t("overall.month12")) }}</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Datepicker",
  props: {
    value: {
      type: [String, null],
    },
  },
  computed: {
    localMonth() {
      return this.month === 0 ? 11 : this.month - 1;
    },
    daysNumber() {
      return new Date(this.year, this.localMonth, 0).getDate();
    },
    firstDay() {
      let tempDate = new Date(this.year, this.localMonth, 1).getDay();
      return tempDate === 0 ? 6 : tempDate - 1;
    },
    currentValue() {
      const reg = /^([1-2][0-9][0-9][0-9])-(0[1-9]|1[1-2])-([0-2][0-9]|3[0-1])$/;
      if (typeof this.value === "string" && reg.test(this.value)) {
        const [year, month, day] = this.value.split("-").map((val) => parseInt(val));
        return { year, month, day };
      }
      return null;
    },
    parseBeautifulDisplay() {
      if (this.currentValue !== null) {
        return (
          this.currentValue.day +
          " " +
          this.$t("overall.month" + this.currentValue.month) +
          " " +
          this.currentValue.year
        );
      }
      return "";
    },
  },

  data() {
    return {
      isOn: false,
      month: null,
      year: null,
      day: null,
    };
  },
  watch: {
    value() {
      this.init();
    },
  },
  methods: {
    isActive(d) {
      if (
        this.currentValue !== null &&
        this.year === this.currentValue.year &&
        this.localMonth + 1 === this.currentValue.month &&
        d === this.currentValue.day
      ) {
        return {
          active: true,
        };
      }
    },
    switchMonth(sign) {
      if (sign > 0) {
        this.month = this.month === 12 ? 1 : this.month + 1;
        if (this.month === 1) this.year++;
      } else {
        this.month = this.month === 1 ? 12 : this.month - 1;
        if (this.month === 12) this.year--;
      }
    },
    substr3(val) {
      return val.substring(0, 3);
    },
    selectValue(day) {
      this.day = day;
      this.$emit("input", this.year + "-" + ("0" + this.month).slice(-2) + "-" + ("0" + this.day).slice(-2));
      this.togglePicker();
    },
    togglePicker() {
      this.isOn = !this.isOn;
    },
    init() {
      const reg = /^([1-2][0-9][0-9][0-9])-(0[1-9]|1[1-2])-([0-2][0-9]|3[0-1])$/;
      if (typeof this.value === "string" && reg.test(this.value)) {
        [this.year, this.month, this.day] = this.value.split("-").map((val) => parseInt(val));
      } else {
        const date = new Date();
        this.year = date.getFullYear();
        this.month = date.getMonth() + 1;
        this.day = date.getDate();
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
